const RegLoginInputs = ({ name, type, icon, label, placeholder, onChange, value, id, maxLength, minLength, ...props }) => {

    return (
        <>
            <label htmlFor="lastname" className="text-[13px] font-[500px] leading-5">{label}</label>
            <input
                type={type || "text"}
                required
                value={value}
                className="pl-4 appearance-none required rounded-md border border-[#5B2E4F] relative block w-full focus:outline-none
             px-3 py-3 text-[14px] font-[300px] bg-[#F8F1F6] placeholder-[#33343D]
             text-gray-900 sm:text-sm placeholder:text-[13px] placeholder:font-[500px] placeholder:text-gray-400 leading-5 "
                placeholder={placeholder || "Fill in the details"}
                onChange={onChange}
                id={id}
                maxLength={maxLength}
                minLength={minLength}
                {...props}
                onSubmit={(e) => e.preventDefault()}
            />
        </>
    )
}

export default RegLoginInputs